module.exports = __webpack_public_path__ + "img/image-01.38e1be45.jpg";